import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PartHandlingService } from '../../../../phf.service';
import { Subject } from 'rxjs';
import { PartDetailService } from '../part-detail.service';
import { FilterableService } from '../../../../../mesc/filterable-service';
import { PartListService } from '../../part-list.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'part-handling-tab',
  templateUrl: './part-handling-tab.component.html',
  styleUrls: ['../part-detail.component.scss']
})
export class PartHandlingTabComponent implements OnInit {
  part: any;
  editForm: FormGroup;
  isEditing: boolean;
  isLoading = false;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  sideService: FilterableService;


  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.part = dataItem;
    }
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly partHandlingService: PartHandlingService,
    private readonly partListService: PartListService,
    public readonly messageService: PartDetailService,

  ) {
    this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.isEditing = message.editing;
      });
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group(PartHandlingEditForm);
    this.editForm.get('IsActive').setValue(true);
    this.messageService.partHandlingDataObject = this.editForm; // Sets pointer from messageService Part-Handling to this formGroup

    this.sideService = this.partListService.lookupData.SideViewDto;
    this.getPartHandling();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Calls Part Handling API and populates view with part handling info
   * calls Side API with part handling object
   */
  private getPartHandling() {
    if (this.part.Id) {
      this.partHandlingService.read("/part/" + this.part.Id, true)
        .then(partHandlingResult => {
          if (partHandlingResult) {
            this.editForm.reset(partHandlingResult);
            if(!this.checkAvailableAssist()) this.editForm.get('Assist').setValue('false');
            if(!this.checkAutoCapable()) this.editForm.get('AutoRacking').setValue('false');
            if (this.editForm.get('PresentationId').value) { this.handleSideChange(this.editForm.get('PresentationId').value) }
          }
          this.isLoading = false;
        })
    }
    else { this.isLoading = false; }
  }

  public checkAvailableAssist(){
    if(this.messageService.pressDataObject && this.messageService.pressDataObject.get('AvailableAssist').value === false){
      return false;
    }
    return true;
  }

  public checkAutoCapable(){
    if(this.messageService.pressDataObject && this.messageService.pressDataObject.get('RoboticLoading').value === false){
      return false;
    }
    return true;
  }

  isAutoRacking = () => {
    if(this.editForm.get('AutoRacking').value === true){
      return true;
    }
    return false;
  }

  onKeyUp = (e) => {
    if (isNaN(e.target.valueAsNumber)) {
      try {
        e.target.value = parseInt(e.target.value);
      } catch (e) {
        e.target.value = '';
      }
    }
  }

  handleSideChange = (dataItem) => {
    const side = this.sideService.value.find(x => x.Id === dataItem);
    this.editForm.get('Presentation').setValue(side ? side.Name : '');
  }

}

const PartHandlingEditForm = {
  Id: [],
  PartId: [],
  PresentationId: [],
  PartsPerLift: [],
  PeoplePerLift: [],
  WalkDistance: [],
  SortingDisplacement: [],
  NumberPeopleLoading: [],
  NumberPeopleSorting: [],
  Assist: [],
  ManualSorting: [],
  Presentation: [],
  TotalNumberOfUtilizedWorkStations: [],
  IsActive: [],
  AutoRacking: [],
}
